import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Constant from "../utils/constant";
import { validateOnboardingForm } from "../utils/Validation";

const MAX_FILE_SIZE = 1 * 1024 * 1024; // 1MB

const useOnboardingForm = () => {
  const [employeeData, setEmployeeData] = useState({});
  // const [companyData, setCompanyData] = useState([

  // ]);
  const [companyData, setCompanyData] = useState([
    {
      company_name: "",
      job_title: "",
      start_date: "",
      end_date: "",
      pay_slip: null,
      relieving_letter: null,
      signed_resignation_letter: null,
      offer_letter: null,
    },
  ]);

  const [familyDetail, setFamilyDetail] = useState([]);
  const [class10Details, setClass10Details] = useState({});
  const [class12Details, setClass12Details] = useState({});
  const [chequePhoto, setChequePhoto] = useState(null);
  const [photoFile, setPhotoFile] = useState({});
  const [errors, setErrors] = useState({});
  const [photoLoad, setPhotoLoad] = useState(false);
  const [btnClicked, setBtnClicked] = useState(false);
  const [showCredentialsModal, setShowCredentialsModal] = useState(false);
  const [employeeCredentials, setEmployeeCredentials] = useState(null);

  // API Data States
  const [manager, setManager] = useState([]);
  const [department, setDepartment] = useState([]);
  const [role, setRoles] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [pincodes, setPincodes] = useState([]);
  const [permanentCities, setPermanentCities] = useState([]);
  const [permanentPincodes, setPermanentPincodes] = useState([]);
  const [workLocations, setWorkLocations] = useState([]);
  const [filteredWorkLocations, setFilteredWorkLocations] = useState([]);

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const [
          managersRes,
          departmentsRes,
          rolesRes,
          statesRes,
          workLocationsRes,
        ] = await Promise.all([
          axios.get(`${Constant.BASE_URL}hrms/listManager`),
          // axios.get(`http://localhost:1051/hrms/listManager`),

          axios.post(`${Constant.BASE_URL}hrms/listDepartment?page&limit`),
          axios.post(`${Constant.BASE_URL}hrms/listRoles?page&limit`),
          axios.get(`${Constant.BASE_URL}hrms/listStates`),
          // axios.get(`http://localhost:1051/hrms/listStates`),
          // axios.get(`${Constant.BASE_URL}hrms/listStates`),
        ]);

        setManager(managersRes.data.data);
        setDepartment(departmentsRes.data.data);
        setRoles(rolesRes.data.data);
        setStates(statesRes.data.data);
        if (workLocationsRes.data && workLocationsRes.data.data) {
          const locationNames = workLocationsRes.data.data.map(
            (loc) => loc.state
          );
          setWorkLocations(locationNames);
          setFilteredWorkLocations(locationNames);
        }
      } catch (error) {
        console.error("Error fetching initial data:", error);
      }
    };
    fetchInitialData();
  }, []);

  const uploadDocument = async (file) => {
    if (file.size > MAX_FILE_SIZE) {
      alert("File is too large! Please upload a file smaller than 1MB.");
      return null;
    }

    const formData = new FormData();
    formData.append("documentData", file);

    setPhotoLoad(true);
    try {
      const response = await axios.post(
        `${Constant.BASE_URL}hrms/addDocuments`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      setPhotoLoad(false);
      if (response.data.status === 1) {
        return response.data.photoURL;
      } else {
        console.error("Upload failed:", response.data.message);
        alert("File upload failed.");
        return null;
      }
    } catch (error) {
      setPhotoLoad(false);
      console.error("Error uploading file:", error);
      alert("Something went wrong while uploading. Try again.");
      return null;
    }
  };
  const generateEmployeeId = async () => {
    setBtnClicked(true);
    try {
      const response = await axios.get(
        `${Constant.BASE_URL}hrms/generateEmployeeID`
        // ` http://localhost:1051/hrms/generateEmployeeID `
      );
      if (response.data.status === 1) {
        setEmployeeData((prev) => ({
          ...prev,
          employee_id: response.data.employee_id,
        }));
      } else {
        alert(response.data.message || "Failed to generate ID");
      }
    } catch (error) {
      console.error("Error generating Employee ID:", error);
      alert("Something went wrong while generating ID.");
    } finally {
      setBtnClicked(false);
    }
  };
  const handleInputChange = useCallback(async (e, section, index = null) => {
    const { name, files, value } = e.target;

    if (files && files[0]) {
      const file = files[0];
      const uploadedUrl = await uploadDocument(file);

      if (uploadedUrl) {
        if (section === "employee") {
          setEmployeeData((prevData) => ({ ...prevData, [name]: uploadedUrl }));
        } else if (section === "class10") {
          setClass10Details((prev) => ({ ...prev, [name]: uploadedUrl }));
        } else if (section === "class12") {
          setClass12Details((prev) => ({ ...prev, [name]: uploadedUrl }));
        } else if (section === "cheque") {
          setChequePhoto(uploadedUrl);
        }
        // ... handle other sections
      }
    } else {
      // Handle non-file inputs
      if (section === "employee") {
        setEmployeeData((prevData) => ({ ...prevData, [name]: value }));
      } else if (section === "Family" && index !== null) {
        setFamilyDetail((prev) => {
          const updated = [...prev];
          updated[index][name] = value;
          return updated;
        });
      } else if (section === "class10") {
        setClass10Details((prev) => ({ ...prev, [name]: value }));
      } else if (section === "class12") {
        setClass12Details((prev) => ({ ...prev, [name]: value }));
      }
    }
  }, []); // Add dependencies if needed for useCallback

  const handleInputChangeCompany = useCallback(
    async (e, type, index) => {
      const { name, files, value } = e.target;
      const updatedData = [...companyData];

      if (files && files[0]) {
        const file = files[0];
        const uploadedURL = await uploadDocument(file);
        if (uploadedURL) {
          updatedData[index][name] = uploadedURL;
          setCompanyData(updatedData);
        }
      } else {
        updatedData[index][name] = value;
        setCompanyData(updatedData);
      }
    },
    [companyData]
  ); // Dependency on companyData

  // --- Address Fetching Logic ---
  const fetchCities = useCallback(async (stateName, isPermanent = false) => {
    if (stateName) {
      try {
        const response = await axios.post(
          `${Constant.BASE_URL}hrms/listCities`,
          // `http://localhost:1051/hrms/listCities`,

          { stateName }
        );
        if (response.data.status === 1) {
          isPermanent
            ? setPermanentCities(response.data.data)
            : setCities(response.data.data);
        } else {
          isPermanent ? setPermanentCities([]) : setCities([]);
        }
      } catch (error) {
        console.error("Error fetching cities:", error);
        isPermanent ? setPermanentCities([]) : setCities([]);
      }
    } else {
      isPermanent ? setPermanentCities([]) : setCities([]);
    }
  }, []);

  const fetchPincodes = useCallback(async (cityName, isPermanent = false) => {
    if (cityName) {
      try {
        const response = await axios.post(
          `${Constant.BASE_URL}hrms/listPincode`,
          // `http://localhost:1051/hrms/listPincode`,
          { cityName }
        );
        if (response.data.status === 1) {
          isPermanent
            ? setPermanentPincodes(response.data.data)
            : setPincodes(response.data.data);
        } else {
          isPermanent ? setPermanentPincodes([]) : setPincodes([]);
        }
      } catch (error) {
        console.error("Error fetching pincodes:", error);
        isPermanent ? setPermanentPincodes([]) : setPincodes([]);
      }
    } else {
      isPermanent ? setPermanentPincodes([]) : setPincodes([]);
    }
  }, []);

  const handleStateChange = useCallback(
    (e) => {
      const stateName = e.target.value;
      handleInputChange(e, "employee");
      setCities([]);
      setPincodes([]);
      setEmployeeData((prev) => ({ ...prev, city: "", pincode: "" }));
      fetchCities(stateName);
    },
    [handleInputChange, fetchCities]
  );

  const handleCityChange = useCallback(
    (e) => {
      const cityName = e.target.value;
      handleInputChange(e, "employee");
      setPincodes([]);
      setEmployeeData((prev) => ({ ...prev, pincode: "" }));
      fetchPincodes(cityName);
    },
    [handleInputChange, fetchPincodes]
  );

  const handlePermanentStateChange = useCallback(
    (e) => {
      const stateName = e.target.value;
      handleInputChange(e, "employee");
      setPermanentCities([]);
      setPermanentPincodes([]);
      setEmployeeData((prev) => ({ ...prev, pa_city: "", pa_pincode: "" }));
      fetchCities(stateName, true);
    },
    [handleInputChange, fetchCities]
  );

  const handlePermanentCityChange = useCallback(
    (e) => {
      const cityName = e.target.value;
      handleInputChange(e, "employee");
      setPermanentPincodes([]);
      setEmployeeData((prev) => ({ ...prev, pa_pincode: "" }));
      fetchPincodes(cityName, true);
    },
    [handleInputChange, fetchPincodes]
  );

  const addJobSection = () => {
    const newCompany = {
      company_name: "",
      job_title: "",
      start_date: "",
      end_date: "",
      pay_slip: null,
      relieving_letter: null,
      signed_resignation_letter: null,
      offer_letter: null,
    };
    setCompanyData([...companyData, newCompany]);
  };
  const removeCompanySection = (index) => {
    if (companyData.length > 1) {
      setCompanyData((prevCompanies) =>
        prevCompanies.filter((_, i) => i !== index)
      );
    }
  };
  const AddFamilyMember = () => {
    setFamilyDetail((prev) => [
      ...prev,
      {
        member_name: "",
        relation: "",
        member_dob: "",
        occupation: "",
        member_contact_number: "",
      },
    ]);
  };
  const deleteFamily = (index) => {
    if (familyDetail.length > 1) {
      setFamilyDetail((prev) => prev.filter((_, i) => i !== index));
    }
  };

  const deleteFile = (fieldName, index = null) => {
    if (index !== null) {
      setCompanyData((prev) => {
        const updated = [...prev];
        updated[index][fieldName] = null;
        return updated;
      });
    } else {
      setEmployeeData((prev) => ({ ...prev, [fieldName]: null }));
      if (fieldName === "chequePhoto") setChequePhoto(null);
      // Also clear from photoFile if you're using it for previews
      setPhotoFile((prev) => {
        const newPhotoFile = { ...prev };
        delete newPhotoFile[fieldName];
        return newPhotoFile;
      });
    }
  };

  const handleWorkLocationChange = (e) => {
    const { value } = e.target;
    handleInputChange(e, "employee");
    if (value) {
      setFilteredWorkLocations(
        workLocations.filter((location) =>
          location.toLowerCase().includes(value.toLowerCase())
        )
      );
    } else {
      setFilteredWorkLocations(workLocations);
    }
  };

  const handleWorkLocationSelect = (location) => {
    const syntheticEvent = {
      target: { name: "work_location", value: location },
    };
    handleInputChange(syntheticEvent, "employee");
    // setShowWorkLocationDropdown(false); // If you have a state for dropdown visibility
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formErrors = validateOnboardingForm(employeeData, companyData);
    setErrors(formErrors);

    if (Object.keys(formErrors).length > 0) {
      alert("Please fix the errors before submitting.");
      return;
    }

    try {
      const updatedEmployeeData = {
        employeeData: { ...employeeData },
        workingCompany: companyData,
        familyDetail: familyDetail,
      };

      const response = await fetch(
        `${Constant.BASE_URL}hrms/onboardingEmployee`,
        // `http://localhost:1051/hrms/onboardingEmployee`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(updatedEmployeeData),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `Server responded with status ${response.status}: ${errorText}`
        );
      }

      const data = await response.json();

      if (data && data.status === 1) {
        // Store credentials and show modal
        setEmployeeCredentials({
          employee_id: data.employee_id,
          password: data.password,
          role_name: data.role_name,
          attendance_type: data.attendance_type,
        });
        setShowCredentialsModal(true);
      } else {
        throw new Error(data.message || "An unknown error occurred.");
      }
    } catch (error) {
      alert(`Failed to add employee. Reason: ${error.message}`);
    }
  };

  return {
    employeeData,
    setEmployeeData,
    companyData,
    setCompanyData,
    familyDetail,
    setFamilyDetail,
    class10Details,
    setClass10Details,
    class12Details,
    setClass12Details,
    chequePhoto,
    setChequePhoto,
    photoFile,
    setPhotoFile,
    errors,
    setErrors,
    photoLoad,
    setPhotoLoad,
    btnClicked,
    setShowCredentialsModal,
    employeeCredentials,
    showCredentialsModal,
    manager,
    department,
    role,
    states,
    cities,
    pincodes,
    permanentCities,
    permanentPincodes,
    workLocations,
    filteredWorkLocations,
    handleInputChange,
    handleStateChange,
    handleCityChange,
    handlePermanentStateChange,
    handlePermanentCityChange,
    handleInputChangeCompany,
    addJobSection,
    removeCompanySection,
    AddFamilyMember,
    deleteFamily,
    deleteFile,
    handleWorkLocationChange,
    handleWorkLocationSelect,
    handleSubmit,
    generateEmployeeId,
  };
};

export default useOnboardingForm;
